export default function AgenciesDirective() {
  return {
    template: require('./agencies.html'),
    scope: {
      auditId: '=',
      audit: '=',
      agencies: '=',
      auditTypes: '=',
      coordinators: '=',
      objectDataTypes: '=',
      refreshAudit: '=',
      isEdit: '=',
    },
    controller: 'AgenciesController',
    controllerAs: 'agenciesVM',
    bindToController: true,
    replace: true
  };
}
